// Labeled undo history. Click any step to jump the document to that point;
// steps after the current position are redoable and shown dimmed.

import { useStore } from '../state/store'
import { IconClose, IconHistory } from './icons'

export function HistoryPanel() {
  const past = useStore((s) => s.past)
  const future = useStore((s) => s.future)
  const jumpBy = useStore((s) => s.jumpBy)
  const setOverlay = useStore((s) => s.setOverlay)

  return (
    <div className="dialog history-pop holo-frame" role="dialog" aria-label="Undo history">
      <div className="dialog-head">
        <IconHistory size={15} />
        <h2>History</h2>
        <button className="quiet icon-btn" onClick={() => setOverlay(null)} aria-label="Close (Esc)">
          <IconClose size={12} />
        </button>
      </div>
      <div className="history-list">
        <button className="history-item" onClick={() => jumpBy(-past.length)} disabled={past.length === 0}>
          <span className="idx">0</span>
          Session start
        </button>
        {past.map((entry, i) => (
          // Jumping to entry i lands AFTER its action ran: undo the steps above it.
          <button
            key={i}
            className={i === past.length - 1 ? 'history-item current' : 'history-item'}
            onClick={() => jumpBy(-(past.length - 1 - i))}
          >
            <span className="idx">{i + 1}</span>
            {entry.label}
          </button>
        ))}
        {future.map((entry, j) => (
          <button key={`f${j}`} className="history-item future" onClick={() => jumpBy(j + 1)}>
            <span className="idx">{past.length + j + 1}</span>
            {entry.label}
          </button>
        ))}
        {past.length === 0 && future.length === 0 && (
          <p className="hint" style={{ padding: '4px 10px' }}>
            Edits appear here as labeled steps.
          </p>
        )}
      </div>
    </div>
  )
}
